module.exports = __webpack_public_path__ + "static/img/compomics_logo_2019_neg.a5c7af92.png";